export default __webpack_public_path__ + "static/media/par-2.95a11c09.png";